import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Image.css';

// the Image component (as opposed to ImageComponent) does not show a lightbox
export default class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      error: false,
    }
    this.onImageLoad = this.onImageLoad.bind(this);
    this.onImageError = this.onImageError.bind(this);
  }

  onImageLoad() {
    if (this.refs.img) {
      this.setState({ loaded: true });
    }
  }

  onImageError() {
    if (this.refs.img) {
      this.setState({ loaded: true, error: true });
    }
  }

  componentDidMount() {
    var imgTag = ReactDOM.findDOMNode(this.refs.img);
    var imgSrc = imgTag.getAttribute('src');
    var img = new window.Image();
    img.onload = this.onImageLoad;
    img.onerror = this.onImageError;
    img.src = imgSrc;
  }

  render() {
    var { className, ...props } = this.props;
    var rootClassName = className ? className + ' image' : 'image';
    if (this.state.loaded) {
      rootClassName += ' image-loaded';
    }

    if (this.state.error) {
      rootClassName += ' image-error';
    }
    // eslint-disable-next-line
    return <img ref="img" {...props} className={rootClassName} />
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/Image.jsx